// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

/*
getDeepLink(route: string, params: object) is a function that generates a deep link URL. It takes in two parameters:

  - route: a string that represents the route of the deep link. If this parameter is not provided or is an empty string, the route will not be included in the generated URL.
  - params: an object that represents the query parameters to be included in the deep link. It will be converted to a URLSearchParams object and appended to the generated URL. If this parameter is not provided or is an empty object, no query parameters will be included in the generated URL.

The function uses the config object to get the domain and template ID for the deep link. These values are used to construct the base URL of the deep link.

The route and params are then added to the URL, if they are provided. The route is added after the template ID and before the query parameters, while the params are added after the route and are separated by a ? character.

The function returns the generated deep link URL as a string.

Example of Usage:

const route = "home";
const params = {
  key1: "value1",
  key2: "value2"
};
const deepLink = getDeepLink(route, params);
console.log(deepLink);
//https://example.com/templateId/home?key1=value1&key2=value2
*/
function getDeepLink(domain, templateId, route, params) {
  const queryParams = new URLSearchParams(params)
  const encodedURI = encodeURI(
    `https://${domain}/${templateId}${route ? `/${route}` : ''}${
      params ? `?${queryParams.toString()}` : ''
    }`,
  )
  return encodedURI
}

export { getDeepLink }
